export default __webpack_public_path__ + "assets/3cc449e7ec6c6f78e6f41c02e2cb0416.jpg";